import {
  APP_ROLES,
  BROKER_ROLE,
  CASHIER_ROLE,
  DRIVER_ROLE,
  HOC_ROLE,
  HOF_ROLE,
  TRANSPORTER_ROLE,
} from "../consts/AppRoles";

import { usePermission } from "../hooks/usePermission";

export const OnlyForCashier = ({ role = "", children }) => {
  if (APP_ROLES[role].toLowerCase() === CASHIER_ROLE) return <>{children}</>;
};

export const OnlyForTransporter = ({ role = "", children }) => {
  if (APP_ROLES[role].toLowerCase() === TRANSPORTER_ROLE)
    return <>{children}</>;
};

export const OnlyForHeadFinance = ({ role = "", children }) => {
  if (APP_ROLES[role].toLowerCase() === HOF_ROLE) return <>{children}</>;
};

export const OnlyForHeadCashier = ({ role = "", children }) => {
  if (APP_ROLES[role].toLowerCase() === HOC_ROLE) return <>{children}</>;
};

export const OnlyForBroker = ({ role = "", children }) => {
  if (APP_ROLES[role].toLowerCase() === BROKER_ROLE) return <>{children}</>;
};

export const OnlyForDriver = ({ role = "", children }) => {
  if (APP_ROLES[role].toLowerCase() === DRIVER_ROLE) return <>{children}</>;
};

// Allowing fro mulitiple users at a time
export const OnlyFor = ({ roles = [], role = "", children }) => {
  const isAllowed = usePermission(roles);
  if (isAllowed) return <>{children}</>;
};

// Allowing fro mulitiple users at a time
export const permitUser = (roles = [], role = "") => {
  return roles.includes(role);
};
